import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useRef } from "react";
import { useCountUp } from "react-countup";
import { usePrevious } from "__barrel_optimize__?names=usePrevious!=!react-use";
import { formatTimecodeValue } from "~/utils/VideoUtils";
export const VideoTimecodeFrames = /*#__PURE__*/ memo((param)=>{
    let { frames, frameCount } = param;
    const countRef = useRef(null);
    const { reset, update } = useCountUp({
        ref: countRef,
        duration: 1,
        start: 0,
        end: frameCount || 0,
        formattingFn: formatTimecodeValue
    });
    const prevFrames = usePrevious(frames);
    useEffect(()=>{
        if (frames && prevFrames && frames > prevFrames) {
            update(frames);
        } else if (frames) {
            /**
       * When the next value is lower than the previous value, we need to reset the count up before
       * updating the value to prevent the count up from counting down.
       */ reset();
            update(frames);
        }
    }, [
        frames,
        prevFrames,
        reset,
        update
    ]);
    return /*#__PURE__*/ _jsx("span", {
        ref: countRef
    });
});
VideoTimecodeFrames.displayName = "VideoTimecodeFrames";
